import classNames from 'classnames';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../components/ui/Dialog';
import { Button } from '../../../../components/ui/Button';
import SolutionDetailView from './SolutionDetailView';
import { useState } from 'react';
import { apiService } from '../../../../utils/api';
import { useMaterialPattern } from '../hooks/api';
import CombinedPatternPreview from './modals/patternGallery/CombinedPatternPreview';

const fetchSolutionDetail = async (id) => {
  return (await apiService.get(`/api/v1/solution/${id}/last-version/`)).data;
};

const SolutionGalleryCard = ({ solution, selected, onSelect, onPreview }) => {
  const { foregroundPattern, backgroundPattern } = useMaterialPattern(solution.material_pattern);

  const hasPattern = !!solution.material_pattern;

  return (
    <div
      className={classNames('w-[200px] bg-color4 p-2', {
        'border border-color7': selected === solution.id,
      })}
    >
      <div className="bg-color3 h-[150px]">
        {hasPattern ? (
          <CombinedPatternPreview
            foreground={foregroundPattern}
            foregroundColor={solution.material_pattern.fg_color_hex || '#000000'}
            foregroundScale={solution.material_pattern.fg_scale}
            background={backgroundPattern}
            backgroundColor={solution.material_pattern.bg_color_hex || '#FFFFFF'}
            backgroundScale={solution.material_pattern.bg_scale}
          />
        ) : solution?.image_url ? (
          <img className="object-cover h-full w-full" src={solution.image_url} />
        ) : null}
      </div>
      <span className="uppercase text-xs">{solution.title}</span>
      <div className="text-xs uppercase flex justify-between">
        <button
          className="px-2 py-1 hover:bg-color7 hover:text-white"
          onClick={() => onPreview(solution.id_detail)}
          data-testid={`solution-gallery-preview-btn-${solution.id}`}
        >
          Náhled
        </button>
        {selected === solution.id ? (
          <button
            className="px-2 py-1 hover:bg-color7 hover:text-white"
            onClick={() => onSelect(null)}
            data-testid={`solution-gallery-deselect-btn-${solution.id}`}
          >
            Zrušit
          </button>
        ) : (
          <button
            className="px-2 py-1 hover:bg-color7 hover:text-white"
            onClick={() => onSelect(solution)}
            data-testid={`solution-gallery-select-btn-${solution.id}`}
          >
            Zvolit
          </button>
        )}
      </div>
    </div>
  );
};

const SolutionGallery = ({ solutions, selected, onSelect }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [solutionPreview, setSolutionPreview] = useState(null);

  const showSolutionPreview = async (id) => {
    if (!id) return;

    const solution = await fetchSolutionDetail(id);
    setSolutionPreview(solution);
    setShowPreview(true);
  };

  return (
    <>
      <div className="h-auto flex flex-wrap gap-1 text-center">
        {(solutions || []).map((solution) => (
          <SolutionGalleryCard
            key={solution.id}
            solution={solution}
            selected={selected}
            onSelect={onSelect}
            onPreview={showSolutionPreview}
          />
        ))}
      </div>
      <Dialog open={showPreview} onOpenChange={() => setShowPreview(false)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Preview</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <SolutionDetailView data={solutionPreview} editDisable />
          </DialogBody>
          <DialogFooter>
            <Button
              key={1}
              variant="outline"
              onClick={() => setShowPreview(false)}
              data-testid="solution-gallery-preview-close-btn"
            >
              Zavřít
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SolutionGallery;
